import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../services/usuario.service';
import { NgxSpinnerService } from "ngx-spinner";
import { take } from 'rxjs/operators';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';

export interface GruposElemento {
  ID: string;
  Nome: string;
  Input: boolean;
}

@Component({
  selector: 'app-consultar-grupo',
  templateUrl: './consultar-grupo.component.html',
  styleUrls: ['./consultar-grupo.component.scss', '../../styles/estilo.padrao.scss']
})
export class ConsultarGrupoComponent implements OnInit {
  uid;
  bBtSalvar: boolean = false;

  displayedColumns: string[] = ['Nome', 'Consultar'];
  grupos: GruposElemento[] = [];
  gruposSource;
  idGrupoCadastrado;
  filtroTabela = "";

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private spinner: NgxSpinnerService,
    private activatedRoute: ActivatedRoute
  ) {
    this.uid = localStorage.getItem('uid');
    this.spinner.show('consultar-grupos');

    //Pegar o grupo recém cadastrado
    this.activatedRoute.queryParams.subscribe(value => {
      const dado = value;
      if (dado.IDGrupo) {
        this.idGrupoCadastrado = dado.IDGrupo;
      }
    });

  }

  ngOnInit(): void {

    this.usuarioService.getGrupos(this.uid).pipe(take(1)).subscribe(snap => {
      this.grupos = [];

      if (snap.length > 0) {
        var dados;

        snap.forEach((item, index) => {
          dados = item.payload.val();

          if (item.key === this.idGrupoCadastrado) {
            this.filtroTabela = dados.Nome;
          }

          this.grupos.push({
            ID: item.key,
            Nome: dados.Nome,
            Input: false,
          });
        });

        //Ordena alfabeticamente
        this.grupos.sort((a, b) => a.Nome.localeCompare(b.Nome));
        // this.grupos.sort(function (a, b) {
        //   if (a.Nome < b.Nome) { return -1; }
        //   if (a.Nome > b.Nome) { return 1; }
        //   return 0;
        // });

        // this.usuarioService.setLog("Consulta de grupos", null, this.uid);


        this.gruposSource = new MatTableDataSource(this.grupos);
        this.gruposSource.paginator = this.paginator;

        if (this.idGrupoCadastrado) {
          this.gruposSource.filter = this.filtroTabela;
        }

        setTimeout(() => this.spinner.hide('consultar-grupos'), 300);
      } else {
        this.toastr.error("Não foi possível localizar os grupos!", 'Erro');
        setTimeout(() => this.spinner.hide('consultar-grupos'), 300);
      }
    });
  }

  async atualizar() {
    this.spinner.show('default');

    const map = this.grupos;

    let b = true;
    for (let i = 0; i < map.length; i++) {
      if (map[i].Input && map[i].Nome.length === 0) {
        b = false;
      }
    };

    if (b) {
      try {

        await Promise.all(map.map(async (value) => {
          if (value.Input) {
            const contents = await this.usuarioService.updateGrupo(this.uid, value.Nome.trim(), value.ID).then(resp => {
              return;
            });
          } else
            return;

        })).then(resp => {

          this.toastr.success('Grupo atualizado!', 'Status', { progressBar: true, positionClass: 'toast-top-center', });

          this.usuarioService.setLog("Alteração de Grupos", map, this.uid);

          setTimeout(() => {
            this.spinner.hide('default');
            this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
              this.router.navigate(["/pages/consultar-grupo"]));
            this.toastr.clear();
          }, 800);
        });

      } catch (e) {
        console.log(e)
        this.spinner.hide('default');
        this.usuarioService.setLog("Erro ao alterar grupos. Erro: " + e, map, this.uid);

        this.toastr.error('Erro ao atualizar grupo!', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
        this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
          this.router.navigate(["/pages/consultar-grupo"]));
      }
    } else {
      this.toastr.error('Preencha todos os campos corretamente!', 'Error', { progressBar: true, positionClass: 'toast-top-center', });
      setTimeout(() => this.spinner.hide('default'), 500);
    }
  }

  editarGrupo(dados) {
    const index = this.grupos.indexOf(dados)
    this.grupos[index].Input = true;
    this.bBtSalvar = true;
    setTimeout(() => document.getElementById(dados.ID).focus(), 100);
  }

  aplicarFiltroTabela(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.gruposSource.filter = filterValue.trim().toLowerCase();

    if (this.gruposSource.paginator) {
      this.gruposSource.paginator.firstPage();
    }
  }

  voltar() {
    this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
      this.router.navigate(["/pages/consultar-grupo"]));
  }
}
